import React from 'react';
import { useTranslation } from 'react-i18next';
import './PageNotFound.scss';

const PageNotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="text-center page-not-found mt-5">
      <p><i className="fa fa-frown-o" /></p>
      <h3>{t('pageNotFound.title')}</h3>
      <p>{t('pageNotFound.message')}</p>
      <a href="/dashboard">
        <button className="btn btn-action" >
          {t('pageNotFound.label')}
        </button>
      </a>
    </div>
  );
};

export default PageNotFound;

